import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Location } from '@angular/common';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { SellerContract } from "src/app/entity/SellerContract";
import { Utility } from "src/app/entity/Utility";
import { Pair } from "src/app/obj/Pair";
import { AuthService } from "src/app/service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "src/app/service/general.service";
import { FormsModule } from "@angular/forms";
import { QuillEditorComponent } from "ngx-quill";
import { MatTab, MatTabGroup } from "@angular/material/tabs";

@Component({
    selector: "app-seller-terms-contract-dialog",
    templateUrl: "../../../html/incs/seller-terms-contract-dialog.component.html",
    imports: [FormsModule, QuillEditorComponent, MatTabGroup, MatTab,]
})
export class SellerTermsContractDialogComponent extends AbstractSellerComponent {
    sellerContractId: number = 0;
    sellerContract: SellerContract = new SellerContract();
    deleteTermsDocument: boolean = false;
    validDate: string = "";
    useUpload: boolean = null!;

    termRescissions: string[] = ["Not Applicable", "Midnight of the 1st business day after the date of Agreement", "Midnight of the 2nd business day after the date of Agreement", "Midnight of the 3rd business day after the date of Agreement", "Midnight of the 4th business day after the date of Agreement", "Midnight of the 5th business day after the date of Agreement"];

    utilities: Utility[] = null!;
    rateClasses: Pair[] = [];
    loadZones: Pair[] = [];
    terms: number[] = [6, 12, 18, 24, 36];
    fileToUpload: File = null!;

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        public dialogRef: MatDialogRef<any>,
        private _location: Location,
        dialog: MatDialog,
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        if (this.sellerContract.termRescission == null) {
            this.sellerContract.termRescission = 2;
        }
        this._location.go("seller/terms");
    }

    setSellerContract(sellerContract: SellerContract) {
        this.sellerContract = sellerContract;
        this.useUpload = (this.sellerContract.termsDocument != null);
    }

    sendForm(): void {
        this.clearErrors();
        if (this.sellerContract.name == null || this.sellerContract.name.length == 0) {
            this.addError("name");
        }
        if (this.sellerContract.termRescission == null || isNaN(+this.sellerContract.termRescission)) {
            this.addError("termRescission");
        }
        if (this.useUpload && this.fileToUpload == null && this.sellerContract.termsDocument == null) {
            this.addError("fileToUpload");
        }
        if (!this.useUpload && (this.sellerContract.terms == null || this.sellerContract.terms.length == 0)) {
            this.addError("terms");
        }
        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above.");
            return;
        }
        this.sellerContract.termRescission = +this.sellerContract.termRescission;
        if (this.useUpload) {
            this.sellerContract.terms = "";
        } else {
            if (this.sellerContract.id > 0 && this.sellerContract.termsDocument != null) {
                this.deleteTermsDocument = true;
            }
            this.sellerContract.termsDocument = null!;
            this.fileToUpload = null!;
        }

        //Fix of Quill bug
        if (this.sellerContract.terms != null && this.sellerContract.terms.length > 0) {
            this.sellerContract.terms = this.sellerContract.terms.replace(/&nbsp;|\u00A0/g, ' ');
        }
        if (this.sellerContract.disclosureStatement != null && this.sellerContract.disclosureStatement.length > 0) {
            this.sellerContract.disclosureStatement = this.sellerContract.disclosureStatement.replace(/&nbsp;|\u00A0/g, ' ');
        }

        if (this.sellerContract.id > 0) {
            this.generalService.updateSellerContract(this.sellerContract, this.fileToUpload, this.deleteTermsDocument)
                .subscribe(
                    {
                        next: (res: any) => {
                            if (res > 0) {
                                this.cancel();
                            }
                        },
                        error: (err: any) => {
                            if (err.status == 400) {
                                this.setErrorText(err.error);
                            }
                        }
                    });
        } else {
            this.generalService.addSellerContract(this.sellerContract, this.fileToUpload)
                .subscribe(
                    {
                        next: (res: any) => {
                            if (res > 0) {
                                this.cancel();
                            }
                        },
                        error: (err: any) => {
                            if (err.status == 400) {
                                this.setErrorText(err.error);
                            }
                        }
                    }
                );
        }
    }

    selectUseUpload(useUpload: boolean): void {
        this.useUpload = useUpload;
        this.resetError("fileToUpload");
        this.resetError("terms");
    }

    handleFileInput(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileToUpload = (target.files as FileList).item(0) as File;
        this.resetError("fileToUpload");
    }

    reloadSellerContract(): void {
        if (this.sellerContractId > 0) {
            this.generalService.getSellerContract(this.sellerContractId)
                .then(c => {
                    if (c != null) {
                        this.sellerContract = c;
                        this.sellerContractId = c.id;
                        this.useUpload = (this.sellerContract.terms == null) || (this.sellerContract.terms.length == 0);
                    } else {
                        this.sellerContract = new SellerContract();
                    }
                });
        } else {
            this.sellerContract = new SellerContract();
        }
    }

    deleteFile(ifExisting: boolean): void {
        if (!ifExisting) {
            this.fileToUpload = null!;
        } else {
            this.sellerContract.termsDocument = null!;
            this.deleteTermsDocument = true;
        }
    }

    downloadFile(ifExisting: boolean) {
        if (!ifExisting) {
            this.generalService.sendFileToClient(this.fileToUpload);
        } else {
            this.generalService.openDocument(this.sellerContract.termsDocument.key);
        }
    }

    cancel(): void {
        this.dialogRef.close(null!);
    }

}
